import React from 'react';
import CSSclasses from './DrawerToggle.module.css'

const drawToggle = (props) => (
  <div onClick={props.clicked} className={CSSclasses.DrawerToggle}>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default drawToggle
